import React from "react";

export const BinSmallTrashIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.66663 7.33398V11.334V7.33398Z"
        fill="var(--inzeloop-ds-color-text-graphite)"
      />
      <path
        d="M6.66663 7.33398V11.334"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33337 7.33398V11.334"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2762 14.2761C12.0261 14.5262 11.687 14.6667 11.3334 14.6667H4.66671C4.31309 14.6667 3.97395 14.5262 3.7239 14.2761C3.47385 14.0261 3.33337 13.687 3.33337 13.3333V4"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 4H14"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33337 4.00065V2.66732C5.33337 2.3137 5.47385 1.97456 5.7239 1.72451C5.97395 1.47446 6.31309 1.33398 6.66671 1.33398H9.33337C9.687 1.33398 10.0261 1.47446 10.2762 1.72451C10.5262 1.97456 10.6667 2.3137 10.6667 2.66732V4.00065"
        stroke="var(--inzeloop-ds-color-icon-primary)"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
